
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-indigo-400/10 rounded-full blur-2xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
            Ready to
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-orange-400">
              Dominate Your Market?
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-indigo-100 mb-12 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Join 200+ businesses that have transformed their online presence and achieved explosive growth with our proven strategies.
          </p>

          {/* Value Props */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-xl text-gray-900"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Fast Results
              </h3>
              <p className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                See significant improvements in just 90 days
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-green-400 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-xl text-gray-900"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Guaranteed ROI
              </h3>
              <p className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                We don't get paid unless you see results
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-blue-400 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-xl text-gray-900"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Expert Team
              </h3>
              <p className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                Dedicated specialists for your success
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
            <button className="bg-white text-indigo-600 px-10 py-5 rounded-2xl text-xl font-bold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
              <i className="ri-calendar-line mr-3"></i>
              Book Free Strategy Call
            </button>
            <button className="border-2 border-white/30 text-white px-10 py-5 rounded-2xl text-xl font-bold hover:bg-white/10 transition-all duration-300 whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
              <i className="ri-download-line mr-3"></i>
              Get Free Growth Audit
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center gap-8 text-indigo-200">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-green-400"></i>
              <span className="text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>No Long-term Contracts</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-green-400"></i>
              <span className="text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>30-Day Money Back</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-green-400"></i>
              <span className="text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Free Initial Consultation</span>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 pt-12 border-t border-white/20">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>500%</div>
              <div className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Average Growth</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>200+</div>
              <div className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Success Stories</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>90</div>
              <div className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Days to Results</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>24/7</div>
              <div className="text-indigo-200 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Expert Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
